import { Injectable, OnDestroy, inject } from "@angular/core";
import { Subscription } from "rxjs";
import { AuthService } from "./auth.service";

@Injectable({ providedIn: "root" })
export class SmartchatService implements OnDestroy {
    private readonly SCRIPT_ID = "smartchat-widget-script";
    private authSub: Subscription;
    private authService = inject(AuthService);

    constructor() {
        this.authSub = this.authService.currentUser$.subscribe((user) => {
            if (user) {
                this.mountWidget();
            } else {
                this.unmountWidget();
            }
        });
    }

    private mountWidget(): void {
        if (document.getElementById(this.SCRIPT_ID)) {
            return;
        }

        const logoUrl = `${window.location.origin}/assets/images/lens-blueprint-logo.svg`;
        const script = document.createElement("script");
        script.id = this.SCRIPT_ID;
        script.src =
            "https://chat.smartchat.africa/dist/smartchat-web.umd.js";
        script.setAttribute("data-client-id", "26");
        script.setAttribute("data-bot-name", "Lens Blueprint Assistant");
        script.setAttribute("data-position", "bottom-right");
        script.setAttribute("data-bubble-color", "#1e3a8a");
        script.setAttribute("data-primary-color", "#1e3a8a");
        script.setAttribute("data-bot-id", "193");
        script.setAttribute("data-logo-url", logoUrl);
        document.body.appendChild(script);
    }

    private unmountWidget(): void {
        const script = document.getElementById(this.SCRIPT_ID);
        if (script) {
            script.remove();
        }

        // Remove all widget DOM elements by various naming patterns the library may use
        document
            .querySelectorAll(
                '[id*="smartchat"], [class*="smartchat"],' +
                '[id*="sc-widget"], [class*="sc-widget"],' +
                '[data-client-id="26"]'
            )
            .forEach((el) => el.remove());

        // Remove any iframes injected by the widget
        document.querySelectorAll('iframe').forEach((iframe) => {
            const src = iframe.src || "";
            if (src.includes("smartchat") || src.includes("chat.smartchat")) {
                iframe.remove();
            }
        });

        // Clear SmartChat session data so the next login starts a fresh session
        [localStorage, sessionStorage].forEach((storage) => {
            Object.keys(storage)
                .filter((key) => key.toLowerCase().includes("smartchat"))
                .forEach((key) => storage.removeItem(key));
        });
    }

    ngOnDestroy(): void {
        this.authSub.unsubscribe();
    }
}
